(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-anyway-launch"] && !Shopify.designMode) return;
  try {
    
  function initializeBuildAnyway(){
    document.querySelectorAll('[data-ba-page]').forEach(root=>{
      const form=root.querySelector('[data-ba-form]');if(!form||form.dataset.bound)return;form.dataset.bound='true';
      const button=root.querySelector('[data-ba-submit]'),status=root.querySelector('[data-ba-status]'),success=root.querySelector('[data-ba-success]');
      const messages=JSON.parse(root.querySelector('[data-ba-messages]').textContent);const originalButton=button.innerHTML;
      root.querySelectorAll('a[href="#ba-privacy"]').forEach(link=>link.addEventListener('click',()=>{root.querySelector('#ba-privacy').open=true;}));
      root.querySelectorAll('[data-ba-view-button]').forEach(control=>control.addEventListener('click',()=>{
        const view=control.dataset.baViewButton;
        root.querySelector('[data-ba-product-front]').hidden=view!=='front';
        root.querySelector('[data-ba-product-lettering]').hidden=view!=='lettering';
        root.querySelectorAll('[data-ba-view-button]').forEach(item=>item.setAttribute('aria-pressed',String(item===control)));
      }));
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(button.disabled)return;if(!form.reportValidity())return;
        status.textContent='';root.querySelectorAll('[data-ba-error]').forEach(el=>el.textContent='');form.querySelectorAll('[aria-invalid]').forEach(el=>el.removeAttribute('aria-invalid'));
        const fields=new FormData(form);const payload={name:fields.get('name'),email:fields.get('email'),phone:fields.get('phone'),size:fields.get('size'),website:fields.get('website'),consent:fields.get('consent')==='on',smsConsent:fields.get('smsConsent')==='on'};
        button.disabled=true;button.textContent=messages.sending;form.setAttribute('aria-busy','true');
        try{
          const endpoint=new URL(root.dataset.endpoint);const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
          let response;try{response=await fetch(endpoint.href,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',body:JSON.stringify(payload),signal:controller.signal});}finally{clearTimeout(timeout);}
          const result=await response.json();
          if(!response.ok||!result.ok){
            let firstInvalid=null;Object.entries(result.fieldErrors||{}).forEach(([name,message])=>{const input=form.elements.namedItem(name);const error=root.querySelector('[data-ba-error="'+name+'"]');if(input){input.setAttribute('aria-invalid','true');firstInvalid=firstInvalid||input;}if(error)error.textContent=message;});
            status.textContent=Object.keys(result.fieldErrors||{}).length?messages.check:messages.error;(firstInvalid||status).focus();return;
          }
          form.hidden=true;success.hidden=false;root.querySelector('[data-ba-already]').hidden=!result.alreadyJoined;root.querySelector('[data-ba-new]').hidden=!!result.alreadyJoined;if(result.alreadyJoined)root.querySelector('[data-ba-success-heading]').textContent=messages.alreadyTitle;
          if(typeof result.manageUrl==='string'&&/^\/leave\?token=[a-f0-9]{64}$/.test(result.manageUrl)){const manage=root.querySelector('[data-ba-manage]');manage.href=new URL(result.manageUrl,endpoint.origin).href;manage.hidden=false;}
          success.scrollIntoView({block:'center',behavior:'auto'});success.focus({preventScroll:true});
        }catch{status.textContent=messages.error;status.focus();}finally{button.disabled=false;button.innerHTML=originalButton;form.removeAttribute('aria-busy');}
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initializeBuildAnyway);}else{initializeBuildAnyway();}
  document.addEventListener('shopify:section:load',initializeBuildAnyway);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
